import React, { useState, useEffect } from "react";
import "./FAQContent.css";
import AOS from "aos";
import "aos/dist/aos.css";

import FAQAccordian from "./FAQAccordian";

function FAQContent() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);
  return (
    <>
      <div className="main-banner faqBanner">
        <img
          src="images/FAQ/FaqBanner.png"
          alt="banner"
          className="banner-img"
        />
        <div className="bannerText">
          <h1 className="fadBannerHead">FAQ</h1>
          {/* <p className="infoText">Lorem Ipsum is simply dummy text of the printing</p> */}
        </div>

      </div>
      <div className="faq-outer-wrapper">
        <div className="faqInnerWrap">
          <img src="images/FAQ/Intersection1.png" className="cornerImage1" alt="" />
          <img src="images/FAQ/Intersection2.png" className="cornerImage2" alt="" />
          <FAQAccordian />
          <img src="images/FAQ/Intersection3.png" className="cornerImage3" alt="" />
        </div>

      </div>
    </>
  );
}

export default FAQContent;
